import BenchmarkService from '@/services/BenchmarkService'
import * as env from '@/helpers/env'
import {
  getUrlFloat,
} from '@/helpers/UrlParam'



export const getPixelRatio = function (mode) {

  let benchmarkLevel = BenchmarkService.benchmarkLevel
  let fps = BenchmarkService.gpuTier?.fps || 0
  let tier = BenchmarkService.gpuTier?.tier || 0
  let pixelRatio = window.devicePixelRatio

  function doLog(gamePixelRatio) {
    console.log('getPixelRatio', JSON.stringify({
      mode,
      benchmarkLevel,
      fps,
      tier,
      gamePixelRatio,
      // nativePixelRatio: window.devicePixelRatio
    }, null, 2))
  }


  // ************************************************************
  //
  // URL OVERRIDE
  //
  // ************************************************************
  if (getUrlFloat('pixelRatio')) {
    doLog(getUrlFloat('pixelRatio'))
    return getUrlFloat('pixelRatio')
  }



  // ************************************************************
  //
  // FALLBACK
  //
  // ************************************************************
  if (mode == 'fallback') {
    doLog(Math.min(window.devicePixelRatio, 3))
    return Math.min(window.devicePixelRatio, 3)
  }



  // ************************************************************
  //
  // FULL
  //
  // ************************************************************

  if (env.android && benchmarkLevel >= 1) {
    // ANDROID

    if (benchmarkLevel >= 50) pixelRatio = 2
    else if (benchmarkLevel >= 35) pixelRatio = 1.5
    else pixelRatio = 1

  } else {

    // IOS

    if (tier >= 5) pixelRatio = 2
    else if (tier >= 4) pixelRatio = 2
    else if (tier >= 3) pixelRatio = 1.5
    else pixelRatio = 1
  }

  pixelRatio = Math.min(pixelRatio, 2)
  doLog(pixelRatio)

  return pixelRatio
}